import { useMemo } from 'react'
import { useRouter } from 'next/router'
import useBootstrapData from '@/hooks/useBootstrapData'
import { isRebookFlightDetails } from '@/shared-utils/flight-rebook-helpers'
import { initialState } from '../SearchForm/utils'
import type { FlightFormStateType } from '../types'

// Hook to enable/handle Prepopulation, SEM, Rebook/Modify & initialization of flight form state
const useInitialFlightFormValues = (isRebook = false, isModify = false) => {
  const { pathname, query } = useRouter()
  const isHomepage = pathname === '/'

  const {
    isMobile,
    prePopData,
    flightRebookOrModifyDetails,
    appName,
    appVersion,
    webstats: { clientGUID: cguid }
  } = useBootstrapData()

  const {
    flights,
    flightType,
    cabinClass,
    adultCount,
    childrenCount,
    infantCount
  } = prePopData?.flights ?? {}

  const rebookCarrierName = flightRebookOrModifyDetails?.carrierName ?? ''
  const rebookCreditAmount =
    flightRebookOrModifyDetails &&
    isRebookFlightDetails(flightRebookOrModifyDetails)
      ? flightRebookOrModifyDetails.creditAmount
      : ''

  const initialValues: FlightFormStateType = useMemo(() => {
    return {
      ...initialState,
      ...(flights && { flights }),
      ...(flightType && { flightType }),
      ...(cabinClass && { cabinClass }),
      travelers: {
        adults: adultCount ?? 1,
        children: childrenCount ?? 0,
        lapInfants: infantCount ?? 0,
        childrenAges: {},
        rooms: 0
      },
      ...((isRebook || isModify) &&
        flightRebookOrModifyDetails && {
          cabinClass: flightRebookOrModifyDetails.cabinClass,
          travelers: {
            adults: flightRebookOrModifyDetails.passengerCount.adultCount ?? 1,
            children:
              flightRebookOrModifyDetails.passengerCount.childrenCount ?? 0,
            lapInfants:
              flightRebookOrModifyDetails.passengerCount.infantCount ?? 0,
            childrenAges: {},
            rooms: 0
          }
        })
    }
  }, [
    flights,
    flightType,
    cabinClass,
    adultCount,
    childrenCount,
    infantCount,
    isRebook,
    isModify,
    flightRebookOrModifyDetails
  ])

  return {
    initialValues,
    isMobile,
    cguid,
    isHomepage,
    appName,
    appVersion,
    rebookCarrierName,
    rebookCreditAmount,
    query
  }
}

export default useInitialFlightFormValues
